import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { FileUploader } from "react-drag-drop-files";
import Subheading from "../../../components/common/Subheading";
import { ALLOWED_FILE_TYPES, NO_FILE_TEXT } from "../constants/fileInputConstants";

/**
 * FileInput component for handling file uploads with preview and clear functionality
 * @param {Object} props - Component properties
 * @param {File|null} props.file - Currently selected file
 * @param {Function} props.setFile - Function to update the selected file
 */
function FileInput({ file, setFile }) {
  const handleClearFile = () => setFile(null);
  const fileName = file?.name ?? NO_FILE_TEXT;

  return (
    <Grid container direction="row" alignItems="flex-start" justifyContent="center" spacing={2}>
      <Grid size="auto" my={3} textAlign="center">
        <Subheading text={fileName} />
      </Grid>

      <Grid size="auto" my={1.5} mx={3}>
        <Button
          variant="outlined"
          color="error"
          startIcon={<DeleteIcon />}
          sx={{ ml: 1, height: 48 }}
          onClick={handleClearFile}
          fullWidth
        >
          Clear Input
        </Button>
      </Grid>

      <Grid size="auto">
        <FileUploader handleChange={setFile} name="file" types={ALLOWED_FILE_TYPES} />
      </Grid>
    </Grid>
  );
}
export default FileInput;
